import { useEffect, useState } from "react";
import { Singleton } from "../../../core/services/Singleton";
import { TalentService } from "../../../core/services/TalentService";
import { BasicTable, MASK_BOOLEAN } from "../../theme/Component/BasicTable";
import { ListMenu } from "../../theme/Component/ListMenu";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { _ProofAccounts } from "../../../core/services/dataBean/EntityCatalog";
import { PrintJson } from "../../theme/Component/PrintJson";

interface Props {
    proof: any;
}

export const ProofAnswer = ({ proof }: Props) => {

    const services = new TalentService();
    const single = Singleton.getInstance();
    const _proofAccounts = useDataBean(_ProofAccounts);
    const [lista, setLista] = useState([]);
    const [bean, setBean] = useState<any>({});
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalConfirm, setModalConfirm] = useState<any>({ name: 'Confirmar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        if (proof ) {
            getLista()
        }
    }, [proof])

    const idBean = 'IDProofAnswer';

    const head = [
        { title: 'Pregunta', property: "Question" },
        { title: 'Respuesta', property: "ResponseValue" },
        { title: 'Justificación', property: "JustificaAnswer" },
    ]

    const setRowBean = (bean: any) => {
       //console.log("Row : ", bean);
        setBean(bean);
    }

    const getLista = () => {
        
        
        _proofAccounts.instance.getResponsesByIDAccount(proof.IDTest,proof.IDAccount).then(
            (resp:any)=>{
                setLista(resp);
            }
        )
    }

   

    const updateItem = () => {
        setModal({ ...modal, "view": false })

    }

    const agregarItem = () => {
        let b = {
        }
        setBean(b);
        setModal({ ...modal, 'view': true });
    }

  

  

    return (
        <>
            <div className="row">
                <BasicTable body={lista} head={head} rowSet={setRowBean}></BasicTable>                
            </div>
        </>
    )
}